import styled from "styled-components";

const RequiredSpan = styled.span.attrs({
  children: " *",
})`
  color: ${({ theme }) => theme.danger};
`;

export default RequiredSpan;
